document.addEventListener('DOMContentLoaded', function() {
  // Find all quality standards sections on the page
  const sections = document.querySelectorAll('[data-section-id]');
  
  sections.forEach(sectionElement => {
    // Only process quality-standards sections
    if (!sectionElement.classList.contains('quality-standards')) {
      return;
    }
    
    const sectionId = sectionElement.dataset.sectionId;
    const tooltip = document.getElementById(`quality-standards-tooltip-${sectionId}`);
    const tooltipCloseButtons = document.querySelectorAll(`#quality-standards-tooltip-${sectionId} [data-tooltip-close]`);
    
    // Helper function to check if mobile
    function isMobile() {
      return window.innerWidth <= 749;
    }
    
    // Product data storage
    const productData = new Map();
    
    // Initialize hotspot data from blocks
    const hotspots = sectionElement.querySelectorAll('.quality-standards__hotspot');
    hotspots.forEach(hotspot => {
      const hotspotId = hotspot.dataset.hotspotId;
      const badge = sectionElement.querySelector(`[data-badge-id="${hotspotId}"]`);
      
      if (badge) {
        const titleEl = badge.querySelector('.quality-standards__badge-title');
        const descriptionEl = badge.querySelector('.quality-standards__badge-description');
        const textEl = badge.querySelector('.quality-standards__badge-text');
        const iconEl = badge.querySelector('.quality-standards__badge-icon img');
        
        productData.set(hotspotId, {
          title: titleEl ? titleEl.textContent.trim() : '',
          description: descriptionEl ? descriptionEl.innerHTML : '',
          text: textEl ? textEl.textContent.trim() : '',
          icon: iconEl ? iconEl.src : null
        });
      }
    });
    
    // Open tooltip (mobile) or badge (desktop)
    function openTooltip(hotspotId) {
      const product = productData.get(hotspotId);
      if (!product) return;
      
      const mobile = isMobile();
      
      if (mobile && tooltip) {
        // Mobile: use tooltip overlay
        const titleEl = tooltip.querySelector('.quality-standards__tooltip-title');
        const descriptionEl = tooltip.querySelector('.quality-standards__tooltip-description');
        const textEl = tooltip.querySelector('.quality-standards__tooltip-text');
        const iconEl = tooltip.querySelector('.quality-standards__tooltip-icon');
        const iconImg = iconEl ? iconEl.querySelector('img') : null;
        
        // Title
        if (product.title && titleEl) {
          titleEl.textContent = product.title;
          titleEl.style.display = 'block';
        } else if (titleEl) {
          titleEl.style.display = 'none';
        }
        
        // Description
        if (product.description && descriptionEl) {
          descriptionEl.innerHTML = product.description;
          descriptionEl.style.display = 'block';
        } else if (descriptionEl) {
          descriptionEl.style.display = 'none';
        }
        
        // Text
        if (product.text && textEl) {
          textEl.textContent = product.text;
          textEl.style.display = 'block';
        } else if (textEl) {
          textEl.style.display = 'none';
        }
        
        // Icon
        if (product.icon && iconImg && iconEl) {
          iconImg.src = product.icon;
          iconImg.alt = product.title || '';
          iconEl.style.display = 'block';
        } else if (iconEl) {
          iconEl.style.display = 'none';
        }
        
        // Show tooltip with inline styles - contained within section
        tooltip.style.position = 'absolute';
        tooltip.style.top = '0';
        tooltip.style.left = '0';
        tooltip.style.right = '0';
        tooltip.style.bottom = '0';
        tooltip.style.width = '100%';
        tooltip.style.height = '100%';
        tooltip.style.background = 'transparent';
        tooltip.style.display = 'flex';
        tooltip.style.alignItems = 'flex-end';
        tooltip.style.justifyContent = 'center';
        tooltip.style.padding = '0px 16px 20px 16px';
        tooltip.style.transform = 'none';
        tooltip.setAttribute('aria-hidden', 'false');
      } else {
        // Desktop: show badge normally
        const badge = sectionElement.querySelector(`[data-badge-id="${hotspotId}"]`);
        const hotspot = sectionElement.querySelector(`[data-hotspot-id="${hotspotId}"]`);
        if (badge && hotspot) {
          badge.style.display = 'flex';
          hotspot.style.display = 'none';
        }
      }
    }
    
    // Close tooltip (mobile) or badge (desktop)
    function closeTooltip() {
      const mobile = isMobile();
      
      if (mobile && tooltip) {
        // Mobile: hide tooltip and reset inline styles
        tooltip.setAttribute('aria-hidden', 'true');
        tooltip.style.position = '';
        tooltip.style.top = '';
        tooltip.style.left = '';
        tooltip.style.right = '';
        tooltip.style.bottom = '';
        tooltip.style.width = '';
        tooltip.style.height = '';
        tooltip.style.background = '';
        tooltip.style.display = '';
        tooltip.style.alignItems = '';
        tooltip.style.justifyContent = '';
        tooltip.style.padding = '';
        tooltip.style.transform = '';
      } else {
        // Desktop: hide all badges and show hotspots
        const badges = sectionElement.querySelectorAll('.quality-standards__badge');
        const hotspots = sectionElement.querySelectorAll('.quality-standards__hotspot');
        badges.forEach(badge => {
          badge.style.display = 'none';
        });
        hotspots.forEach(hotspot => {
          hotspot.style.display = 'block';
        });
      }
    }
    
    // Hotspot click handlers
    hotspots.forEach((hotspot, index) => {
      hotspot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const hotspotId = this.dataset.hotspotId;
        
        const mobile = isMobile();
        if (mobile && tooltip) {
          // Mobile: toggle tooltip
          const isVisible = tooltip.getAttribute('aria-hidden') === 'false';
          if (isVisible) {
            closeTooltip();
          } else {
            openTooltip(hotspotId);
          }
        } else {
          // Desktop: toggle badge
          const badge = sectionElement.querySelector(`[data-badge-id="${hotspotId}"]`);
          if (badge) {
            const isVisible = badge.style.display === 'flex';
            if (isVisible) {
              badge.style.display = 'none';
              this.style.display = 'block';
            } else {
              // Hide all other badges first
              const allBadges = sectionElement.querySelectorAll('.quality-standards__badge');
              const allHotspots = sectionElement.querySelectorAll('.quality-standards__hotspot');
              allBadges.forEach(b => b.style.display = 'none');
              allHotspots.forEach(h => h.style.display = 'block');
              
              // Show this badge
              badge.style.display = 'flex';
              this.style.display = 'none';
            }
          }
        }
      });
    });

    // Badge close buttons (desktop)
    const badgeCloseButtons = sectionElement.querySelectorAll('[data-badge-close]');
    badgeCloseButtons.forEach((button) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const badgeId = this.dataset.badgeClose;
        const badge = sectionElement.querySelector(`[data-badge-id="${badgeId}"]`);
        const hotspot = sectionElement.querySelector(`[data-hotspot-id="${badgeId}"]`);
        
        if (badge && hotspot) {
          badge.style.display = 'none';
          hotspot.style.display = 'block';
        }
      });
    });
    
    // Tooltip close buttons (mobile)
    tooltipCloseButtons.forEach(button => {
      button.addEventListener('click', closeTooltip);
    });
    
    // Close tooltip on outside click (mobile)
    if (tooltip) {
      tooltip.addEventListener('click', (e) => {
        const mobile = isMobile();
        if (mobile && e.target === tooltip) {
          closeTooltip();
        }
      });
      
      // Prevent tooltip content clicks from closing
      const tooltipContent = tooltip.querySelector('.quality-standards__tooltip-content');
      if (tooltipContent) {
        tooltipContent.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }
    }

    // Close open badge on outside click (desktop)
    document.addEventListener('click', (e) => {
      if (isMobile()) return;

      const badges = sectionElement.querySelectorAll('.quality-standards__badge');
      const hasOpenBadge = Array.from(badges).some((badge) => badge.style.display === 'flex');
      if (!hasOpenBadge) return;

      const target = e.target;
      if (!(target instanceof Element)) return;

      // Don't close if the click was inside the open badge or on a hotspot.
      if (target.closest('.quality-standards__badge')) return;
      if (target.closest('.quality-standards__hotspot')) return;

      closeTooltip();
    });
    
    // Handle Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeTooltip();
      }
    });
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        // Close tooltip if switching from mobile to desktop
        if (!isMobile() && tooltip) {
          closeTooltip();
        }
      }, 250);
    });
  });
});

